import { render, staticRenderFns } from "./myReception.vue?vue&type=template&id=6459baaa&scoped=true"
import script from "./myReception.vue?vue&type=script&lang=js"
export * from "./myReception.vue?vue&type=script&lang=js"
import style0 from "./myReception.vue?vue&type=style&index=0&id=6459baaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6459baaa",
  null
  
)

export default component.exports